(() => {
  const SESSION_KEY = 'age_gate_accepted';

  const hasAcceptedInSession = () => {
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === 'true';
    } catch (error) {
      return false;
    }
  };

  const markAcceptedInSession = () => {
    try {
      window.sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (error) {
      // Intentionally no-op when storage is unavailable.
    }
  };

  const openGate = (gate) => {
    gate.hidden = false;
    document.documentElement.classList.add('age-gate-open');
    document.dispatchEvent(new CustomEvent('age-gate:opened'));
  };

  const closeGate = (gate) => {
    gate.hidden = true;
    document.documentElement.classList.remove('age-gate-open');
    document.dispatchEvent(new CustomEvent('age-gate:closed'));
  };

  document.addEventListener('DOMContentLoaded', () => {
    const gate = document.querySelector('[data-age-gate]');
    if (!gate) return;

    const acceptButton = gate.querySelector('[data-age-gate-accept]');
    const rejectButton = gate.querySelector('[data-age-gate-reject]');
    const rejectMessage = gate.querySelector('[data-age-gate-reject-message]');

    if (hasAcceptedInSession()) {
      closeGate(gate);
      return;
    }

    openGate(gate);

    acceptButton?.addEventListener('click', () => {
      markAcceptedInSession();
      closeGate(gate);
    });

    rejectButton?.addEventListener('click', () => {
      if (rejectMessage) rejectMessage.hidden = false;
    });
  });
})();
